import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const archivedWorkItemsJswRoute: InvariantJiraRoute = {
	name: 'software-archived-work-items',
	path: '/jira/software/projects/:projectKey/archived-work-items',
	exact: true,
};
